export const environment = {
  production: true,
  enviromentName: 'PRODUCCION',
  apiUrl450: 'https://wsopa.uaa.mx:450',//'https://buril.uaa.mx:453',
  apiUrl452: 'https://wsreportes.uaa.mx:452',
  apiUrl453: 'https://adquisicionesyobrapublica.uaa.mx'
};
